import ViewCarriersPage from "components/viewCarriers/ViewCarriersPage.component"

const ViewCarriers = () => {
  return (
    <ViewCarriersPage />
  )
}

export default ViewCarriers
